/* Publish by EComposer at 2026-11-04 00:27:17*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gvurnbdkf9f"]=  window.__ectimmers["ecom-gvurnbdkf9f"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-gvurnbdkf9f').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gvurnbdkf9f', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gvurnbdkf9f', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-p8a3ibqg1t9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-p8a3ibqg1t9', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-p8a3ibqg1t9', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-1xk2pmdsmlr').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1xk2pmdsmlr', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1xk2pmdsmlr', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-i5nxk5psm0e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-i5nxk5psm0e', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-i5nxk5psm0e', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}